module.exports = __webpack_public_path__ + "img/create_print.1df7529d.png";